var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExternalLinkinline = function SvgExternalLinkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.353 2.458c0 .347.278.625.625.625h2.659l-5.81 5.808a.625.625 0 0 0 .883.883l5.807-5.808v2.66c0 .346.278.624.625.624a.624.624 0 0 0 .625-.625V2.458a.624.624 0 0 0-.625-.625H9.978a.623.623 0 0 0-.625.625Zm-6.042.209a1.874 1.874 0 0 0-1.875 1.875v8.75c0 1.036.838 1.875 1.875 1.875h8.75a1.874 1.874 0 0 0 1.875-1.875V9.959a.624.624 0 0 0-.625-.625.623.623 0 0 0-.625.625v3.333a.624.624 0 0 1-.625.625h-8.75a.623.623 0 0 1-.625-.625v-8.75c0-.347.279-.625.625-.625h3.333a.623.623 0 0 0 .625-.625.623.623 0 0 0-.625-.625H3.311Z",
    fill: "#7C7C7C"
  })));
};
export default SvgExternalLinkinline;